<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import moment from 'moment'
import product from './product.json'
import DetailWoCard from './DetailWoCard.vue'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import ModalClockInPhoto from '@/components/Modals/ModalClockInPhoto'
import ConfirmationV2 from '@/components/widgets/modals/ConfirmationV2'
import * as workOrderAPI from '@/services/rest-api-sms/lib/work-order/work-order'
import * as vehicleApi from '@/services/rest-api-sms/lib/vehicle/vehicle'
import * as vgroupsApi from '@/services/rest-api-sms/lib/vgroups/vgroups'
import ModalCoordinatorSop from './components/ModalCoordinatorSop.vue'
import { VueEditor, Quill } from 'vue2-editor'
import ImageResize from 'quill-image-resize-vue'
import * as vehicleTypeApi from '@/services/rest-api-sms/lib/vehicle/vehicle-type'
import FormCreateDevice from './components/FormCreateDevice.vue'
import FormDeviceSetToCustomer from './components/FormDeviceSetToCustomer.vue'
import * as companyApi from '@/services/rest-api-sms/lib/company/company'
import * as deviceApi from '@/services/rest-api-sms/lib/device/device'
import * as tasksApi from '@/services/rest-api-sms/lib/tasks/tasks'
import * as fileApi from '@/services/rest-api-sms/lib/file/file'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'
import { adasDmsRows } from './constant'

moment.locale('id')
Quill.register('modules/imageResize', ImageResize)

export default {
  page: {
    title: 'Work Order Form',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    DetailWoCard,
    Multiselect,
    ModalClockInPhoto,
    ConfirmationV2,
    VueEditor,
    ModalCoordinatorSop,
    FormCreateDevice,
    FormDeviceSetToCustomer,
    McButton,
  },

  mixins: [Helper],

  data() {
    return {
      selected: [],
      selectedModel: [],
      allSelected: [],
      indeterminate: null,
      selectedTask: '',
      workOrder: {
        wo_number: null,
        total_fleet: 0,
        wo_type: null,
        is_migrate: false,
        company_id: null,
      },
      woNumber: this.$route.params.woNumber || this.$route.query.wo_number || 0,
      tasks: [],
      products: [],
      licensePlate: null,
      tasksId: null,
      taskType: null,
      sop: [],
      sortBy: 'created_at',
      sortDesc: false,
      loading: false,
      checklist: [],
      isLoading: false,
      isLoadingSendToERP: false,
      rate: {},
      taskId: null,
      batteryPhoto: null,
      batteryPhotoS3: null,
      imeiPhoto: null,
      imeiPhotoS3: null,
      odometerPhoto: null,
      odometerPhotoS3: null,
      licensePlatePhoto: null,
      licensePlatePhotoS3: null,
      rearVehiclePhoto: null,
      rearVehiclePhotoS3: null,
      mediaPreviewTitle: '',
      mediaPreviewUrl: '',
      mediaPreviewDate: '',
      adasDmsData: null,
      expandedAdasDmsTcdId: null,
      tableFields: ['checklist_detail', 'checklist_detail_type'],
      dropdownOptionsMaintenance: [
        { value: 'NC', text: 'Need Check Koordinator' },
        { value: 'NA', text: 'Check Not Ok' },
        { value: 'OK', text: 'Check Ok' },
      ],
      productId: product,
      imei: null,
      vehicleTypes: [],
      selectedManufacturerModel: {},
      selectedVehicleType: {},
      vehicleTypeOptions: {},
      clockInData: null,
      vehicleFullPhoto: null,
      vehicleFullPhotoS3: null,
      mapComponent: {},
      isCheck: false,
      columns: [],
      modalConfirm: false,
      pendingUpdate: null,
      isEditingInternalNote: true,
      showModalCoordinatorSop: false,
      editorSettings: {
        modules: {
          imageResize: {
            displaySize: true,
          },
        },
      },
      selectedImei: null,
      selectedTaskId: null,
      selectedLicensePlate: null,
      taskData: null,
      editTargetVgroups: false,
      vgroupOptions: [],
      set: {
        deviceName: null,
        vendorType: null,
        imei: null,
        phoneNo: null,
        vehicleId: null,
        companies: null,
        selectedVehicle: null,
        selectedVehicleType: null,
        odometer: null,
        hullNo: null,
        vehicleYear: null,
      },
    }
  },

  computed: {
    adasDmsRows() {
      return adasDmsRows
    },
    cancelStatus() {
      if (this.workOrder.wo_status === 'I') return false
      return true
    },

    doneStatus() {
      if (
        this.tasks.filter((x) => !['V', 'RJ'].includes(x.tasks_status)).length ||
        !this.workOrder?.ended_at ||
        !this.workOrder?.verified_at ||
        this.workOrder.wo_status === 'D' ||
        !this.workOrder.total_fleet
      ) {
        return true
      }
      return false
    },

    SOP() {
      return (tasksId, isCheck) => {
        if (isCheck) {
          const taskFound = this.tasks.find((t) => t.tasks_id === tasksId)

          if (taskFound) {
            const result = taskFound

            if (result) {
              return result.task_checklist.filter((checklist) =>
                checklist.wo_type.some((type) => type.includes('H'))
              )
            }
          } else {
            return []
          }
        }

        if (this.workOrder.type == 'install' || this.workOrder.type == 'move') {
          return this.tasks.find((t) => t.tasks_id === tasksId)
            ? this.tasks.find((t) => t.tasks_id === tasksId).task_checklist
            : []
        }

        if (this.workOrder.type == 'maintenance') {
          const taskFound = this.tasks.find((t) => t.tasks_id === tasksId)

          if (taskFound) {
            const result = taskFound

            if (result) {
              return result.task_checklist.filter((checklist) =>
                checklist.wo_type.some((type) => !type.includes('H'))
              )
            }
          } else {
            return []
          }
        }
      }
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)

        return this.task.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.task
      }
    },

    fieldProduct() {
      return [
        {
          key: 'identifier',
          label: this.$t('product.column.identifier'),
          sortable: false,
        },
        {
          key: 'name',
          label: this.$t('product.column.name'),
          sortable: false,
        },
        {
          key: 'qty',
          label: this.$t('product.column.qty'),
          sortable: false,
        },
        {
          key: 'note',
          label: this.$t('product.column.note'),
          sortable: false,
        },
        {
          key: 'healthy',
          label: 'Health',
          sortable: false,
        },
        {
          key: 'override_route',
          label: this.$t('product.column.overrideRoute'),
          sortable: false,
        },
        {
          key: 'line_id',
          label: this.$t('product.column.workOrderLineId'),
          sortable: false,
        },
      ]
    },

    isMove() {
      return this.workOrder?.wo_type === 'move'
    },

    task() {
      const columns = [
        {
          key: 'columnCheck',
          sortable: false,
          thClass: 'mc-table--30',
        },
      ]

      if (this.isMove) {
        // ==== MODE MOVE ====
        columns.push(
          {
            key: 'license_plate',
            label: `${this.$t('task.column.licensePlate')} (${this.$t('task.column.from')})`,
            sortable: true,
          },
          {
            key: 'origin_vgroups',
            label: this.$t('Group Kendaraan (Asal)'),
          },
          {
            key: 'target_license_plate',
            label: `${this.$t('task.column.licensePlate')} (${this.$t('task.column.to')})`,
            sortable: true,
          },
          {
            key: 'target_vgroups',
            label: this.$t('Group Kendaraan (Tujuan)'),
          }
        )
      } else {
        // ==== MODE NORMAL ====
        columns.push({
          key: 'license_plate',
          label: this.$t('task.column.licensePlate'),
          sortable: true,
        })
      }

      // ==== Kolom Umum ====
      columns.push(
        {
          key: 'domain_name',
          label: this.$t('domain.table.domainName'),
          sortable: true,
        },
        {
          key: 'imei',
          label: this.$t('task.column.imei'),
          sortable: true,
        },
        {
          key: 'phone_no',
          label: this.$t('master.list.tracker.phoneNo'),
          sortable: true,
        },
        {
          key: 'device.deviceType.deviceName',
          label: this.$t('task.column.gpsType'),
          sortable: true,
        },
        {
          key: 'category',
          label: this.$t('task.column.category'),
          sortable: false,
        },
        {
          key: 'manufacturerModel',
          label: this.$t('task.column.manufacturer'),
          tdClass: 'mc-table--50',
        },
        {
          key: 'vehicleType',
          label: this.$t('task.column.vehicleType'),
          tdClass: 'mc-table--50',
        },
        {
          key: 'fuelTypeName',
          label: this.$t('task.column.fuelType'),
          sortable: false,
        },
        {
          key: 'odometer',
          label: this.$t('task.column.odometer'),
          sortable: true,
        },
        {
          key: 'hull_no',
          label: this.$t('vehicle.hullNo'),
          sortable: true,
        },
        {
          key: 'created_at',
          label: this.$t('task.column.time'),
          sortable: true,
        },
        {
          key: 'valid_by_username',
          label: this.$t('task.column.validBy'),
          sortable: true,
        },
        {
          key: 'fleet_photo',
          label: this.$t('task.column.fleetPhoto'),
          sortable: true,
        },
        {
          key: 'checking',
          label: this.$t('task.column.checking'),
          show: this.workOrder.wo_type === 'maintenance',
        },
        {
          key: 'sop',
          label: this.$t('task.column.sop'),
        },
        {
          key: 'note',
          label: this.$t('task.column.note'),
          sortable: true,
        },
        {
          key: 'wo_line_id',
          label: this.$t('task.column.workOrderLineId'),
          sortable: false,
        },
        {
          key: 'tasks_status_maintenance',
          label: this.$t('task.column.checkDevice'),
          formatter: (value) => {
            switch (value) {
              case 'C':
                return 'Created'
              case 'NC':
                return 'Need Check Koordinator'
              case 'NA':
                return 'Check Not Ok'
              case 'OK':
                return 'Check Ok'
              case 'D':
                return 'Draft'
              case 'P':
                return 'Plan'
              default:
                return ''
            }
          },
          sortable: true,
          show: this.workOrder.wo_type === 'maintenance',
        },
        {
          key: 'tasks_status',
          label: this.$t('task.column.approve'),
          formatter: (value) => {
            switch (value) {
              case 'C':
                return 'Created'
              case 'R':
                return 'Request'
              case 'I':
                return 'Invalid'
              case 'V':
                return 'Valid'
              case 'D':
                return 'Draft'
              case 'P':
                return 'Plan'
              case 'RJ':
                return 'Reject'
              default:
                return ''
            }
          },
          sortable: true,
        }
      )

      return columns.filter((col) => col.show === undefined || col.show)
    },

    title() {
      return 'Work Order Form TJ'
    },

    manufacturerModelOptions() {
      const manufacturer = this.vehicleTypes.map((item) => {
        return `${item.manufacturer} - ${item.model}`
      })
      const arrayData = [...new Set(manufacturer)].sort()
      return arrayData
    },
    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    TJCompanyIds() {
      const data = this.getFeatureFlagData('customFeature.transjakarta')
      const config = JSON.parse(data?.value || '{}')?.config || []
      return config.map((c) => c.mceasy_company_id)
    },
    TJDomains() {
      const data = this.getFeatureFlagData('customFeature.transjakarta')
      const config = JSON.parse(data?.value || '{}')?.config || []
      return config.map((c) => c.mceasy_domain)
    },
  },

  watch: {
    '$route.params.wo_number': {
      async handler(newWoNumber) {
        this.woNumber = newWoNumber // ← tambahkan baris ini
        this.workOrder.edit_note = false
        this.workOrder.edit_total_Fleet = false
        await this.getWorkOrder(newWoNumber)
        await this.getVehicleType()
      },
      immediate: true,
    },
  },

  async created() {
    this.workOrder.edit_note = false
    this.workOrder.edit_total_Fleet = false
    await this.getWorkOrder(this.$route.params.wo_number)

    const isTJ = this.isTJCompany(this.workOrder.company_id, this.workOrder.domain_name)
    if (!isTJ && this.$route.path.includes('/work-order/validation-tj')) {
      this.$router.replace(`/work-order/validation/form/${this.$route.params.wo_number}`)
    }

    await this.getVehicleType()
  },

  methods: {
    // Method untuk refresh data TANPA mereset flags (saat @data-updated di modal)
    // Hanya update task yang sedang dibuka di modal, preserve button flags
    async refreshTaskDataOnly() {
      try {
        if (!this.woNumber && !this.$route.params.woNumber) return

        const woNumber = this.woNumber || this.$route.params.woNumber
        const qp = { workOrderNumber: woNumber }
        const workOrder = await workOrderAPI.show(qp)

        if (!workOrder || !workOrder.data) return

        // UPDATE HANYA TASK YANG SEDANG DIBUKA
        const updatedTask = workOrder.data.tasks?.find((t) => t.tasks_id === this.selectedTaskId)

        if (updatedTask) {
          // Update taskData tanpa mereset flags
          this.taskData = {
            ...this.taskData,
            ...updatedTask,
            company_id: this.workOrder.company_id,
          }

          // Update task di array tasks juga, tapi preserve button flags
          const taskIndex = this.tasks.findIndex((t) => t.tasks_id === this.selectedTaskId)
          if (taskIndex >= 0) {
            // PENTING: Preserve flags agar tombol tetap aktif
            const preservedFlags = {
              isSopClicked: this.tasks[taskIndex].isSopClicked,
              isCheckClicked: this.tasks[taskIndex].isCheckClicked,
            }
            this.tasks.splice(taskIndex, 1, {
              ...updatedTask,
              ...preservedFlags, // ← KUNCI: Flags tidak di-reset
            })
          }
        }
      } catch (error) {
        console.error('Error refreshing task data:', error)
      }
    },

    // Method untuk full refresh (gunakan hanya saat @saved - setelah SOP complete)
    // Method ini boleh reset flags karena SOP sudah selesai
    async refreshDataOnly() {
      // Refresh ALL data - flags akan di-reset karena ini untuk full refresh
      if (this.woNumber && this.woNumber !== 0) {
        await this.getWorkOrder(this.woNumber)
      } else {
        const wo = this.$route.params.woNumber
        if (wo) {
          await this.getWorkOrder(wo)
        }
      }
    },

    isTJCompany(companyId, domain) {
      return (
        this.TJCompanyIds.some((item) => String(item) === String(companyId)) ||
        this.TJDomains.some((item) => String(item) === String(domain))
      )
    },

    getStatusOptions(item) {
      const current = item.tasks_status

      // Mapping status -> opsi yang tersedia
      if (current === 'V') {
        // Valid → hanya bisa Request / Invalid
        return [
          { value: 'R', text: 'Request' },
          { value: 'I', text: 'Invalid' },
          { value: 'V', text: 'Valid' },
        ]
      } else if (current === 'I') {
        // Invalid → hanya bisa Request
        return [
          { value: 'R', text: 'Request' },
          { value: 'I', text: 'Invalid' },
        ]
      } else if (current === 'RJ') {
        // Reject → hanya bisa Request
        return [
          { value: 'R', text: 'Request' },
          { value: 'RJ', text: 'Reject' },
        ]
      } else if (current === 'R') {
        // Request → bisa Valid / Invalid / Reject
        if (this.workOrder.is_migrate) {
          return [
            { value: 'V', text: 'Valid' },
            { value: 'I', text: 'Invalid' },
            { value: 'RJ', text: 'Reject' },
            { value: 'R', text: 'Request' },
          ]
        }
        return [
          { value: 'V', text: 'Valid' },
          { value: 'I', text: 'Invalid' },
          { value: 'R', text: 'Request' },
        ]
      }

      // Fallback (untuk status lain seperti C, P, D) – tidak ada opsi
      return []
    },
    searchSopByType(woType, operator, tasksId) {
      const taskFound = this.tasks.find((t) => t.tasks_id === tasksId)
      if (taskFound) {
        const result = taskFound

        if (result) {
          return result.task_checklist.find((checklist) => {
            if (operator == 'eq') {
              return checklist.wo_type.some((type) => type.includes(woType))
            } else {
              return checklist.wo_type.some((type) => !type.includes(woType))
            }
          })
        }
      } else {
        return []
      }
    },

    async showSOP(plate, tasksID, item, isCheck) {
      item.edit_tasks_status_maintenance = false
      item.edit_tasks_status = false
      this.selectedTask = item // simpan task object
      if (this.workOrder.wo_status !== 'D') {
        if (this.workOrder.type === 'maintenance') {
          const isFoundChecking = this.searchSopByType('H', 'eq', tasksID)
          const isFoundNotChecking = this.searchSopByType('H', 'ne', tasksID)

          if (isFoundNotChecking) {
            if (item.tasks_status_maintenance != 'NC' && item.tasks_status_maintenance != 'NA') {
              item.isSopClicked = !isCheck
            }
          }

          if (item.tasks_status != 'V') {
            if (isFoundChecking) {
              item.isCheckClicked = isCheck
            }
          }
        } else {
          item.isSopClicked = true
        }
      }

      await this.getSDFormData(item)

      this.tasksId = tasksID
      this.licensePlate = plate
      this.isCheck = isCheck
      await this.$nextTick()
      this.$bvModal.show('modal-sop')
    },

    showFleetPhoto(item) {
      this.licensePlate = item.license_plate
      this.taskId = item.tasks_id
      this.batteryPhoto = item?.accu_file?.name
      this.batteryPhotoS3 = item?.accu_file?.url
      this.imeiPhoto = item?.imei_file?.name
      this.imeiPhotoS3 = item?.imei_file?.url
      this.licensePlatePhoto = item?.license_plate_file?.name
      this.licensePlatePhotoS3 = item?.license_plate_file?.url
      this.odometerPhoto = item?.odometer_file?.name
      this.odometerPhotoS3 = item?.odometer_file?.url
      this.vehicleFullPhoto = item?.vehicle_full_file?.name
      this.vehicleFullPhotoS3 = item?.vehicle_full_file?.url
      this.rearVehiclePhoto = item?.rear_vehicle_file?.name
      this.rearVehiclePhotoS3 = item?.rear_vehicle_file?.url
      this.taskType = item.tasks_type
      this.$bvModal.show('modal-fleetPhoto')
    },

    isVideo(fileUrl) {
      if (!fileUrl) return false
      const sanitizedUrl = fileUrl.split('?')[0].split('#')[0]
      const extension = sanitizedUrl.split('.').pop()?.toLowerCase()
      const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'm4v', '3gp']

      return videoExtensions.includes(extension)
    },

    openMediaPreview(key, label, type) {
      if (!this.adasDmsData[key]?.[`${type}_url`]) {
        this.$toast.error('File media tidak tersedia')
        return
      }

      this.mediaPreviewUrl = this.adasDmsData[key][`${type}_url`]
      this.mediaPreviewTitle = label
      this.mediaPreviewDate = this.adasDmsData[key].alert_date
      this.$bvModal.show('modal-media-preview')
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 400) {
          if (error.response.data.details) {
            error.response.data.details.forEach((element) => {
              if (element.message == 'invalid status') {
                this.$toast.error(`Status tidak valid`)

                return
              }

              this.$toast.error(
                `${error.response.data.error} : ${element.field} ${element.message}`
              )
            })
          }
        } else if (error.response.status === 404) {
          this.$toast.error(`Not found`)

          return
        } else if (error.response.status === 500 || error.response.status === 409) {
          this.$toast.error(error.response?.data?.message)
          return
        } else {
          if (error.response.data.details) {
            error.response.data.details.forEach((element) => {
              this.$toast.error(`${error.response.data.error} : ${element.message}`)
            })
          } else {
            this.$toast.error(error.response.data.error)
          }
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
      return
    },

    async getAdasDmsChecklist(tcd_id, task_id, type) {
      if (this.expandedAdasDmsTcdId === tcd_id) {
        this.expandedAdasDmsTcdId = null
        return
      }

      const qp = {
        type,
      }
      const adasDmsData = await workOrderAPI.showAdasDms(task_id, qp)
      if (!adasDmsData?.data?.data) {
        this.$toast.error(`Data ${type} tidak ditemukan`)
        return
      }
      this.adasDmsData = adasDmsData.data.data
      this.expandedAdasDmsTcdId = tcd_id
      this.hideItem(`tcdPhoto-b-toggle-${tcd_id}`, true)
    },

    async getWorkOrder(woNumber) {
      if (!woNumber || woNumber === 0) {
        this.$toast.error('Nomor WO tidak valid')
        this.loading = false
        return
      }
      this.loading = true
      const qp = {
        workOrderNumber: woNumber,
      }
      const workOrder = await workOrderAPI.show(qp)
      if (!workOrder || !workOrder.data) {
        this.$toast.error('Data WO tidak ditemukan')
        this.loading = false
        return
      }

      // wo field
      this.workOrder.ended_at = workOrder.data?.ended_at
      this.workOrder.verified_at = workOrder.data?.verified_at
      this.workOrder.wo_number = workOrder.data.wo_number
      this.workOrder.customer = workOrder.data.customer
      this.workOrder.qty_plan = workOrder.data.qty_plan
      this.workOrder.teknisi = workOrder.data.teknisi
      this.workOrder.email_teknisi = workOrder.data.email_teknisi
      this.workOrder.state = workOrder.data.state
      this.workOrder.wo_type = workOrder.data.wo_type
      this.workOrder.plan_date = workOrder.data.plan_date
      this.workOrder.wo_status = workOrder.data.wo_status
      this.workOrder.total_fleet = workOrder.data.total_fleet
      this.workOrder.note = workOrder.data.note
      this.workOrder.sign_latitude = workOrder.data.sign_latitude
      this.workOrder.sign_longitude = workOrder.data.sign_longitude
      this.workOrder.wo_id = workOrder.data.wo_id
      this.workOrder.company_id = workOrder.data.company_id
      this.workOrder.domain_name = workOrder.data.domain_name
      this.workOrder.pdf_url = workOrder.data.pdf_url
      this.workOrder.clock_in_photo = workOrder.data.clock_in_photo
      this.workOrder.clock_in_address = workOrder.data.clock_in_address
      this.workOrder.new_internal_note = workOrder.data.new_internal_note
      this.workOrder.internal_note = workOrder.data.internal_note
      this.workOrder.type = workOrder.data.wo_type
      this.workOrder.done_by_username = workOrder.data.done_by_username
      this.workOrder.canceled_by_username = workOrder.data.canceled_by_username
      this.workOrder.is_migrate = workOrder.data.is_migrate
      this.workOrder.work_order_attachments = workOrder.data.work_order_attachments

      // tasks
      const tasks = workOrder.data.tasks ? workOrder.data.tasks : []
      if (tasks && tasks.length > 0) {
        tasks.forEach((task) => {
          // inject target_vehicle agar reactive
          const manufacturer = task.device?.vehicle?.vehicle_type?.manufacturer
          const model = task.device?.vehicle?.vehicle_type?.model

          let manufacturerText = ''
          let modelText = ''

          if (!manufacturer && !model) {
            manufacturerText = ''
            modelText = ''
          } else {
            manufacturerText = manufacturer || 'no data manufacturer'
            modelText = model || 'no data model'
          }

          task.manufacturerModel = task.device
            ? manufacturerText || modelText
              ? `${manufacturerText} - ${modelText}`
              : '-'
            : null

          if (!task.manufacturerModel || task.manufacturerModel === '-') {
            this.vehicleTypeOptions[task.tasks_id] = []
          } else {
            const listDataVehicleType = this.vehicleTypes
            this.vehicleTypeOptions[task.tasks_id] = listDataVehicleType.filter((vehicleType) => {
              return task.manufacturerModel === `${vehicleType.manufacturer} - ${vehicleType.model}`
            })
          }
          const vehicleType = task.device?.vehicle?.vehicle_type
          task.manufacturerModelType = vehicleType
            ? `${task.manufacturerModel} ${vehicleType.type}`
            : null
          task.vehicleType = vehicleType || null
          task.isSopClicked = false
          task.isCheckClicked = false

          //only for maintenance
          if (workOrder.data.wo_type == 'maintenance') {
            if (task.tasks_status == 'V') {
              task.tasks_status_maintenance = 'OK'
            } else if (task.tasks_status == 'R' || task.tasks_status == 'I') {
              task.tasks_status_maintenance = 'OK'
            } else if (task.tasks_status == 'C') {
              task.tasks_status_maintenance = 'C'
            }

            if (task.tasks_status == 'NA' || task.tasks_status == 'NC') {
              task.tasks_status_maintenance = task.tasks_status
              task.tasks_status = null
            }

            if (task.tasks_status == 'OK') {
              task.tasks_status_maintenance = task.tasks_status
              task.tasks_status = null
            }
          }
        })
      }
      this.tasks = tasks
      this.tasks.forEach((task) => {
        if (task.task_checklist !== undefined) {
          task.task_checklist.forEach((tc) => {
            if (tc.flag === 'UnidentifiedComponent') {
              tc.tasks_checklist_detail.forEach((tcd) => {
                if (tcd.note != null) {
                  const noteParts = tcd.note.split('|')
                  if (noteParts.length == 3) {
                    tcd.qty = Number(noteParts[2])
                    tcd.productName = noteParts[1]
                  }

                  //handle old data
                  if (noteParts.length == 2) {
                    tcd.qty = Number(noteParts[1])
                    tcd.productName = noteParts[0]
                  }
                }
              })
            }

            if (tc.flag === 'Replacement') {
              tc.tasks_checklist_detail?.forEach((tcd) => {
                if (tcd.note != null) {
                  const noteParts = tcd.note.split('|')
                  if (noteParts.length == 2) {
                    tcd.componentReplacement = noteParts[1]
                  }
                }
              })
            }
          })
        }
      })

      // rate
      this.rate = workOrder.data.rates ? workOrder.data.rates : {}
      this.rate.rate_id = this.rate?.rate_id ? this.rate.rate_id : 0
      this.rate.sign_photo = workOrder.data.sign_file.name
      this.rate.sign_url = workOrder.data.sign_file.url
      this.rate.sign_selfie_photo = workOrder.data.sign_selfie_file.name
      this.rate.sign_selfie_url = workOrder.data.sign_selfie_file.url

      // product
      this.products = workOrder.data.data_erp ? workOrder.data.data_erp : []
      this.mapComponent = workOrder.data.data_erp
        ? workOrder.data.data_erp.reduce((acc, product) => {
            acc[product.component_id] = product.name
            return acc
          }, {})
        : {}

      this.isEditingInternalNote = !this.workOrder.new_internal_note
      this.loading = false
    },

    async saveInternalNote() {
      this.loading = true

      const payload = {
        internal_note: this.workOrder.new_internal_note,
      }
      const responseWo = await workOrderAPI.update(this.workOrder.wo_id, payload)

      if (responseWo?.data?.status === 200) {
        this.$toast.success('Internal note berhasil disimpan')
      }

      this.loading = false
      this.isEditingInternalNote = false
    },

    editInternalNote() {
      this.isEditingInternalNote = true
    },

    async handleEditorImageAdded(file, Editor, cursorLocation, resetUploader) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('url', 'tasks/')

      const response = await fileApi.upload(formData)

      if (response?.data?.status === 200 || response?.data?.status === 201) {
        const imageUrl = response?.data?.url
        if (imageUrl) {
          Editor.insertEmbed(cursorLocation, 'image', imageUrl)
          resetUploader()
        } else {
          this.$toast.error('Upload failed')
        }
      }
    },

    async editEntity(data, field) {
      this.loading = true
      if (field === 'target_vgroups') {
        if (this.workOrder.wo_status === 'D') {
          this.loading = false
          return
        }
        let params = {
          page: 1,
          limit: 1,
        }
        if (this.workOrder.company_id) {
          params.filters = [`company_id eq ${this.workOrder.company_id}`]
        }

        let response = await vgroupsApi.get(params)
        if (response.status && response.metadata.total_count > 1) {
          params.limit = response.metadata.total_count
          response = await vgroupsApi.get(params)
        }
        if (response.status) {
          this.vgroupOptions = response.data.paginated_result
        }
      }

      if (field === 'vehicleType' || field === 'manufacturerModel') {
        if (!data.item.manufacturerModel) {
          this.vehicleTypeOptions[data.item.tasks_id] = []
        } else {
          const listDataVehicleType = this.vehicleTypes
          this.vehicleTypeOptions[data.item.tasks_id] = listDataVehicleType.filter(
            (vehicleType) => {
              return (
                data.item.manufacturerModel === `${vehicleType.manufacturer} - ${vehicleType.model}`
              )
            }
          )
          data.item.vehicleType = this.vehicleTypeOptions[data.item.tasks_id].find(
            (vehicleType) => {
              return vehicleType.type === data.item.vehicleType.type
            }
          )
        }
        data.item['edit_manufacturerModel'] = true
        data.item[`original_manufacturerModel`] = data.item['manufacturerModel']
        data.item['edit_vehicleType'] = true
        data.item[`original_vehicleType`] = data.item['vehicleType']
      } else {
        data.item[`edit_${field}`] = true
        data.item[`original_${field}`] = data.item[field]
      }
      this.loading = false
    },

    cancelEntity(data, field) {
      this.loading = true
      data.item[`edit_${field}`] = false
      data.item[field] = data.item[`original_${field}`]
      if (field === 'vehicleType') {
        data.item[`edit_manufacturerModel`] = false
        data.item['manufacturerModel'] = data.item[`original_manufacturerModel`]
      }
      this.loading = false
    },

    confirmUpdate(data, field) {
      if (this.workOrder.wo_type == 'maintenance') {
        const hasNewDevice = data.item.task_checklist.some((item) => item.flag === 'NewDevice')

        if (
          hasNewDevice &&
          (data.item.tasks_status_maintenance == 'NC' ||
            data.item.tasks_status_maintenance == 'NA') &&
          (data.item.tasks_status == 'R' ||
            data.item.tasks_status == 'I' ||
            data.item.tasks_status == 'V' ||
            data.item.tasks_status == 'RJ')
        ) {
          this.pendingUpdate = { data, field }
          this.modalConfirm = true

          return
        }

        if (
          data.item.original_tasks_status_maintenance == 'OK' &&
          data.item.tasks_status_maintenance == 'NC'
        ) {
          this.pendingUpdate = { data, field }
          this.modalConfirm = true

          return
        }
      }

      this.updateEntity(data, field)
    },

    async onSubmit() {
      if (this.pendingUpdate) {
        const { data, field } = this.pendingUpdate
        this.modalConfirm = false
        await this.updateEntity(data, field)
        this.pendingUpdate = null
      }
    },

    async updateEntity(data, field) {
      if (field === 'tasks_status' && this.isRejectNoteMissing(data.item)) {
        data.item.edit_note = true
        this.$toast.error('Note wajib diisi saat reject')
        return
      }

      this.loading = true
      data.item[`edit_${field}`] = false

      const payload = { company_id: this.workOrder.company_id }

      // === kondisi field spesifik ===
      if (field === 'vehicleType') {
        payload['vehicle_type_id'] = data.item.vehicleType
          ? data.item.vehicleType.vehicle_type_id
          : null
        payload['fuel_type'] = data.item.vehicleType ? data.item.vehicleType.fuelType : null
        data.item[`edit_manufacturerModel`] = false
      } else if (field === 'wo_line_id') {
        payload[field] = data.item[field] ? parseInt(data.item[field]) : null
      } else {
        payload[field] = data.item[field]
      }

      if (field === 'tasks_status' && data.item.tasks_status === 'RJ') {
        payload.note = data.item.note
      }

      // === copy status jika ada ===
      if (payload['tasks_status_maintenance']) {
        payload['tasks_status'] = payload['tasks_status_maintenance']
      }

      const responseTasks = await tasksApi.update(data.item.tasks_id, payload)
      this.clearEdit()
      if (responseTasks?.status === 200) {
        this.$toast.success(`Data ${field} berhasil diperbarui`)
        await this.getWorkOrder(this.$route.params.wo_number)

        // Reload khusus untuk vehicleType
        if (field === 'vehicleType') {
          window.location.reload()
        }
        this.loading = false
      } else {
        this.tasks[data.index][field] = data.item[`original_${field}`]
        await this.getWorkOrder(this.$route.params.wo_number)
      }
    },

    clearEdit() {
      this.sopClicked = false
      this.tasks = this.tasks.map((item) => ({
        ...item,
        isSopClicked: false,
        isCheckClicked: false,
        edit_vehicleType: false,
        edit_tasks_status: false,
        edit_tasks_status_maintenance: false,
        edit_manufacturerModel: false,
        edit_license_plate: false,
        edit_hull_no: false,
        edit_note: false,
      }))
    },

    toBack() {
      this.$router.back()
    },

    onFleetChange(fleet) {
      this.workOrder.total_fleet = parseInt(fleet)
    },

    onNoteChange(note) {
      this.workOrder.note = note
    },

    checkFieldIsEmpty(checkField) {
      return checkField && checkField.trim()
    },

    isRejectNoteMissing(item) {
      return item.tasks_status === 'RJ' && !this.checkFieldIsEmpty(item.note)
    },

    async toDone() {
      this.loading = true

      const payload = {
        note: this.workOrder.note,
        wo_status: 'D',
        total_fleet: this.workOrder.total_fleet,
        submit_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        type_wo: this.workOrder.wo_type,
        technician: this.workOrder.email_teknisi,
        state_wo: this.workOrder.state,
      }
      const responseWo = await workOrderAPI.update(this.workOrder.wo_id, payload)
      if (responseWo?.data?.status === 200) {
        this.workOrder.wo_status = 'D'
        this.$toast.success(`${this.workOrder.wo_number} berhasil diselesaikan`)
      }

      this.loading = false
      this.$router.push({ name: 'Work Order Validation' })
    },

    async toCancel() {
      this.$bvModal.show('modal-cancelWo')
    },

    async handleCancel() {
      const payload = {
        note: this.workOrder.note,
        wo_status: 'C',
        total_fleet: this.workOrder.total_fleet ? this.workOrder.total_fleet : 0,
      }
      const response = await workOrderAPI.update(this.workOrder.wo_id, payload)

      if (response?.status === 200) {
        this.workOrder.wo_status = 'C'
        this.$toast.success(
          `${this.workOrder.wo_number} ${this.$t('global.successText')} ${this.$t(
            'global.canceled'
          )}`
        )
      }

      this.$router.push({ name: 'Work Order Validation' })
    },

    async setToDraft() {
      const response = await workOrderAPI.setToDraft(this.workOrder.wo_id, null)
      if (response?.status === 200) {
        this.$toast.success(`Status ${this.workOrder.wo_number} berhasil diubah`)
        this.workOrder.wo_status = ''
      }
      this.getWorkOrder(this.workOrder.wo_number, this.workOrder.version)
    },

    async sendToErp() {
      this.isLoadingSendToERP = true

      const payload = { wo_id: this.workOrder.wo_id }
      const response = await workOrderAPI.sendToErp(payload)
      if (response?.data?.status == 200) {
        this.$toast.success(`Success send to ERP`)
      }

      this.isLoadingSendToERP = false
    },

    async downloadFromGenerate(params, filename) {
      const response = await workOrderAPI.exportDetail(this.workOrder.wo_id, params)

      if (response?.status === 200) {
        const url = window.URL.createObjectURL(response?.data)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
      }
    },

    async handleDownload(type) {
      this.isLoading = true
      const filename = `Dok ${type === 'tj_instalasi_pdf' ? 'BAST' : 'Lampiran BAST'} ${
        this.workOrder.wo_number
      }.pdf`

      if (this.workOrder.work_order_attachments) {
        const a = document.createElement('a')
        a.href = this.workOrder.work_order_attachments.find((w) => w.type === type)?.attachment_url
        a.target = '_blank'
        a.rel = 'noopener noreferrer'
        document.body.appendChild(a)
        a.click()
        a.remove()
      } else {
        await this.downloadFromGenerate({type}, filename)
      }
      this.isLoading = false
    },

    checkTable(event, data) {
      if (event) {
        this.selected.push(data)
      } else {
        var myIndex = this.selected.indexOf(data)
        if (myIndex !== -1) {
          this.selected.splice(myIndex, 1)
        }
      }

      const selectableTasks = this.tasks.filter(
        (t) => this.workOrder.wo_status !== 'D' && t.tasks_status !== 'V'
      )
      this.allSelected =
        this.selected.length === selectableTasks.length && selectableTasks.length > 0
    },

    toggleAll() {
      this.selectedModel = []
      this.selected = []
      if (this.allSelected) {
        // Select only those that are selectable
        for (let i = 0; i < this.tasks.length; i++) {
          const task = this.tasks[i]
          const isSelectable = this.workOrder.wo_status !== 'D' && task.tasks_status !== 'V'
          this.selectedModel.push(isSelectable)
          if (isSelectable) {
            this.selected.push(task)
          }
        }
      } else {
        // Deselect all
        for (let i = 0; i < this.tasks.length; i++) {
          this.selectedModel.push(false)
        }
        this.selected = []
      }
    },

    resetData() {
      let self = this
      clearTimeout(self.debounceTimer)
      self.debounceTimer = setTimeout(() => {
        self.$emit('update-change', '')
      }, 500)
    },

    clearDelete() {
      this.allSelected = false
      this.selectedModel = []
      this.selected = []
    },

    async toDelete() {
      let promises = []
      for (const element of this.selected) {
        const res = await this.deleteInstallationDetail(element)
        const taskIndex = this.tasks.findIndex((x) => x.tasks_id === element.tasks_id)
        this.tasks.splice(taskIndex, 1)
        if (!res) continue
        promises.push()
      }

      try {
        await Promise.all(promises)
        this.$toast.success(`Data berhasil dihapus`)
        this.clearDelete()
        this.resetData()
      } catch (error) {
        this.$toast.error(`Task tidak bisa di hapus`)
      }
    },

    async deleteInstallationDetail(element) {
      await tasksApi.remove(element.tasks_id)
    },

    async getVehicleType() {
      const companyIds = [
        1,
        this.TJCompanyIds.find((item) => String(item) === String(this.workOrder.company_id)),
      ].filter(Boolean) // Filter out undefined values

      const params = {
        limit: 1,
        page: 1,
        filters: [`company_id IN (${companyIds.join(', ')})`],
      }
      let response = await vehicleTypeApi.getTJ(params)
      if (response.status) {
        if (response.metadata.total_count > 1) {
          params.limit = response.metadata.total_count
          response = await vehicleTypeApi.getTJ(params)
        }
        this.vehicleTypes = response.data.paginated_result
      }
    },

    selectManufacturer(data) {
      data.item.vehicleType = null
      if (!data.item.manufacturerModel) {
        this.vehicleTypeOptions[data.item.tasks_id] = []
      } else {
        const listDataVehicleType = this.vehicleTypes
        this.vehicleTypeOptions[data.item.tasks_id] = listDataVehicleType.filter((vehicleType) => {
          return (
            data.item.manufacturerModel === `${vehicleType.manufacturer} - ${vehicleType.model}`
          )
        })
      }
    },

    adjustTableHeight(selectName) {
      let table = this.$refs.refTaskTable.$el // Accessing the table element
      let container = table.closest('.table-container') // Finding the parent container
      if (container) {
        table.style.height = 'auto' // Resetting height to auto
      }

      let dropdown = this.$refs.refVehicleType
      if (selectName === 'manufacturer') {
        dropdown = this.$refs.refManufacturer
      }
      if (selectName === 'target_vgroups') {
        dropdown = this.$refs.refTargetVgroups
      }
      table = this.$refs.refTaskTable.$el // Accessing the table element
      container = table.closest('.table-container') // Finding the parent container

      if (dropdown && container) {
        const dropdownHeight = dropdown.$el.clientHeight // Accessing the multiselect element
        const containerHeight = container.clientHeight
        const heightDifference = containerHeight - dropdownHeight

        if (heightDifference > 0) {
          table.style.height = `${dropdownHeight + containerHeight + heightDifference}px`
        }
      }
    },

    hideItem(refName, hide = true) {
      this.$refs[refName][0].$el.style.display = hide ? 'none' : ''
    },

    isElementShown(refName) {
      return this.$refs[refName][0].$el.style.display === ''
    },

    showItem(refName) {
      this.$refs[refName][0].$el.style.display === 'none'
        ? (this.$refs[refName][0].$el.style.display = '')
        : (this.$refs[refName][0].$el.style.display = 'none')
    },

    showModalClockIn() {
      this.clockInData = {
        clock_in_photo: this.workOrder.clock_in_photo,
        wo_number: this.workOrder.wo_number,
        clock_in_address: this.workOrder.clock_in_address,
      }
      this.$bvModal.show('modal-clock-in')
    },

    validateWoLineId(data) {
      // Ensure the value is a positive integer
      if (data.item.wo_line_id === '') {
        // Allow empty value
        return
      }

      // Convert to integer
      let value = parseInt(data.item.wo_line_id)

      // If not a number or negative, reset to empty or 0
      if (isNaN(value) || value < 0) {
        data.item.wo_line_id = ''
      } else {
        // Ensure it's an integer by removing any decimal part
        data.item.wo_line_id = Math.floor(value)
      }
    },

    cancelTargetVgroups() {
      this.loading = true
      this.editTargetVgroups = false
      this.loading = false
    },

    async updateTargetVgroups(data) {
      this.loading = true
      const task = data.item

      const payload = {
        vgroup_ids: task.target_vehicle.vgroups.map((v) => v.vgroup_id),
      }

      try {
        const response = await vehicleApi.updateVehicleVgroups(payload, task.target_vehicle.id)
        if (response.status) {
          this.$mcToast.success('vgroups berhasil diupdate')
          window.location.reload()
        }

        this.editTargetVgroups = false
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },

    async onSaved() {
      this.showModalCoordinatorSop = false
      await this.fetchVehicles()
    },

    onOpenModalCoordinatorSop(taskData) {
      // Set data task yang dipilih
      this.selectedTaskId = taskData.tasks_id
      this.selectedLicensePlate = taskData.license_plate
      this.selectedImei = taskData.imei
      this.taskData = taskData
      this.taskData['company_id'] = this.workOrder.company_id

      // Buka modal
      this.showModalCoordinatorSop = true
    },

    async onSavedCoordinatorSop() {
      // Pastikan woNumber valid sebelum refresh
      if (this.woNumber && this.woNumber !== 0) {
        await this.getWorkOrder(this.woNumber)
      } else {
        // Fallback: ambil dari route params langsung
        const wo = this.$route.params.woNumber
        if (wo) {
          await this.getWorkOrder(wo)
        } else {
          // Jika tetap tidak ada, refresh halaman secara paksa (opsi terakhir)
          window.location.reload()
        }
      }

      // PENTING: Tutup modal setelah SOP selesai
      this.showModalCoordinatorSop = false
    },

    hasDetailWithFlag(item, flag) {
      return item.tasks_checklist_detail?.some((d) => d.flag === flag) || false
    },

    getRCDFormData(task) {
      if (!task) return {}
      const deviceType = task.device?.deviceType
      return {
        imei: task.imei || '',
        phoneNo: task.phone_no || '',
        deviceTypes: deviceType
          ? { deviceCode: deviceType.deviceCode, deviceName: deviceType.deviceName }
          : null,
        companyId: task.company_id || null,
      }
    },

    async getSDFormData(task) {
      if (!task) return {}

      // ✅ Ambil IMEI dari parameter task, bukan dari this.taskData
      const imeiResponse = await deviceApi.getByImei(task.imei).catch(() => null)
      const deviceData = imeiResponse?.data || {}

      const companyResp = await companyApi
        .getById(this.workOrder.company_id, task?.server_region || 'SG')
        .catch(() => null)

      let companyData = null
      if (companyResp?.status && companyResp.data) {
        companyData = companyResp.data
      } else {
        companyData = {
          company_id: task.company_id,
          name: companyData?.name || 'Unknown',
          domain_name: companyData?.domain_name || '',
        }
      }

      const responseVehicleType = await vehicleTypeApi.show(task.vehicle_type_id).catch(() => null)

      let vehicleTypeName = 'Unknown - Unknown Unknown'
      if (responseVehicleType) {
        const mf = responseVehicleType.manufacturer || 'Unknown'
        const t = responseVehicleType.type || 'Unknown'
        vehicleTypeName = `${mf} ${t}`
      }

      // ✅ Simpan ke data.set (yang sudah ada)
      this.set = {
        imei: deviceData.imei || task.imei || '',
        deviceName: deviceData.device_name || '',
        vendorType: companyData.name || '',
        phoneNo: deviceData.phone_no || task.phone_no || '',
        companies: {
          company_id: companyData.company_id,
          name: companyData.name,
          domain_name: companyData.domain_name,
        },
        selectedVehicle: task.vehicle_id
          ? { vehicle_id: task.vehicle_id, license_plate: task.license_plate || '' }
          : null,
        selectedVehicleType: task.vehicle_type_id
          ? {
              vehicle_type_id: task.vehicle_type_id,
              vehicle_type_name: vehicleTypeName,
            }
          : null,
        odometer: task.odometer ? task.odometer / 1000 : 0,
        hullNo: task.hull_no || '',
        vehicleYear: task.vehicle_year || null,
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <div class="clearfix mc-btn-group__list">
        <div class="float-end">
          <i
            class="mc-fa icon-fill_camera fs-4 mx-2"
            style="cursor: pointer"
            @click="showModalClockIn"
          />
          <b-button @click="toBack" variant="outline-primary" class="mx-2">
            <i class="mc-fa icon-outline_arrow-left"></i> {{ $t('global.back') }}
          </b-button>
          <b-button
            v-if="workOrder.wo_status === 'I'"
            variant="primary"
            type="button"
            @click="toCancel"
            class="mx-2"
            :disabled="this.workOrder?.verified_at"
          >
            <i class="mc-fa icon-outline_close"></i> {{ $t('global.cancel') }} WO
          </b-button>
          <b-button
            v-if="workOrder.wo_status === 'C'"
            variant="primary"
            type="button"
            @click="setToDraft"
            class="mx-2"
          >
            <i class="mc-fa icon-outline_file"></i> {{ $t('global.draft') }}
          </b-button>
          <b-button
            v-if="workOrder.wo_status === 'I'"
            variant="primary"
            type="button"
            @click="toDone"
            class="mx-2"
            :disabled="doneStatus || loading"
          >
            <i class="mc-fa icon-outline_all-done"></i>
            <b-spinner v-if="loading" small> </b-spinner>
            {{ $t('global.done') }}
          </b-button>

          <b-button
            v-if="workOrder.wo_status === 'D'"
            variant="primary"
            type="button"
            @click="sendToErp"
            class="mx-2"
            :disabled="isLoadingSendToERP || loading || isLoading"
          >
            <i class="mc-fa icon-outline_file-text"></i>
            <b-spinner v-if="isLoadingSendToERP" small> </b-spinner>
            {{ $t('global.sendToERP') }}
          </b-button>

          <b-dropdown
            v-if="workOrder.wo_status === 'D'"
            id="other-options-unduh"
            right
            menu-class="dropdown-menu-end dropdown-menu-right"
            toggle-tag="div"
            toggle-class="p-0 bg-transparent"
          >
            <template #button-content>
              <McButton
                icon="icon-outline_chevron-down"
                icon-position="right"
                :text="$t('global.download')"
                :disabled="isLoading || loading || isLoadingSendToERP"
              />
            </template>

            <b-dropdown-item @click="handleDownload('tj_instalasi_pdf')">
              {{ $t('workOrder.downloadBAST') }}
            </b-dropdown-item>
            <b-dropdown-item @click="handleDownload('tj_lampiran_pdf')">
              {{ $t('workOrder.downloadBASTAttachment') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <h4 class="card-title">{{ workOrder.wo_number }}</h4>
    <DetailWoCard
      :workOrder="workOrder"
      :tasks="tasks"
      @fleet-change="onFleetChange"
      @note-change="onNoteChange"
      v-if="!loading"
    />

    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">{{ $t('workOrder.table.orderedItemERP') }}</h4>
      </div>
    </div>
    <b-card>
      <div class="table-responsive border border-1">
        <b-table
          class="datatables"
          :items="products"
          :fields="fieldProduct"
          show-empty
          :empty-text="$t('global.emptyTable')"
          :empty-filtered-text="$t('global.emptyFilteredTable')"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :busy="loading"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(healthy)="data">
            {{
              data.item.healthy == 'bad'
                ? 'Bad'
                : data.item.healthy == 'good'
                ? 'Good'
                : data.item.healthy == 'need_check'
                ? 'Need Check'
                : ''
            }}
          </template>
        </b-table>
      </div>
    </b-card>

    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">{{ $t('workOrder.table.installationDetails') }}</h4>
      </div>
    </div>

    <b-card>
      <div class="text-end mb-3">
        <b-button
          v-if="selected.length > 0 && workOrder.type !== 'move'"
          @click="toDelete"
          variant="outline-danger"
          class="mx-2"
        >
          <i class="bx bx-trash-alt"></i> {{ $t('global.delete') }}
        </b-button>
      </div>
      <div class="text-start mb-3">
        <h6 v-if="selected.length > 0" class="mc-row-check">
          <span class="badge btn-success">{{ selected.length }}</span>
          Baris terpilih.
          <a class="color-primary" @click="clearDelete">Bersihkan semua</a>
        </h6>
      </div>
      <div class="table-responsive my-3 border border-1 table-container">
        <b-table
          ref="refTaskTable"
          class="datatables"
          small
          responsive="sm"
          :items="tasks"
          :fields="visibleFields"
          show-empty
          :empty-text="$t('global.emptyTable')"
          :empty-filtered-text="$t('global.emptyFilteredTable')"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :busy="loading"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template #cell(manufacturerModel)="data">
            <template v-if="data.item.edit_manufacturerModel">
              <b-form-group>
                <multiselect
                  ref="refManufacturer"
                  v-model="data.item.manufacturerModel"
                  :options="manufacturerModelOptions"
                  :placeholder="$t('task.column.manufacturer')"
                  @input="selectManufacturer(data)"
                  @open="adjustTableHeight('manufacturer')"
                  open-direction="bottom"
                >
                </multiselect>
              </b-form-group>
            </template>
            <template v-else>
              <div
                v-if="
                  workOrder.wo_status !== 'D' &&
                  data.item.tasks_status !== 'V' &&
                  $store.state.config.selectableVehicleType
                "
                @click="editEntity(data, 'manufacturerModel')"
              >
                <strong>{{ data.value ? data.value : '-' }}</strong>
              </div>
              <div v-else>
                {{ data.value ? data.value : '-' }}
              </div>
            </template>
          </template>
          <template #cell(vehicleType)="data">
            <template v-if="data.item.edit_vehicleType">
              <b-form-group>
                <multiselect
                  ref="refVehicleType"
                  v-model="data.item.vehicleType"
                  :options="vehicleTypeOptions[data.item.tasks_id]"
                  label="type"
                  :placeholder="$t('task.column.vehicleType')"
                  open-direction="bottom"
                  @open="adjustTableHeight"
                />
                <i
                  class="mc-fa icon-outline_checkmark"
                  style="font-size: 20px"
                  @click="updateEntity(data, 'vehicleType')"
                />
                <i
                  class="mc-fa icon-outline_close"
                  style="font-size: 20px"
                  @click="cancelEntity(data, 'vehicleType')"
                />
              </b-form-group>
            </template>
            <template v-else>
              <div
                v-if="
                  workOrder.wo_status !== 'D' &&
                  data.item.tasks_status !== 'V' &&
                  $store.state.config.selectableVehicleType
                "
                @click="editEntity(data, 'vehicleType')"
              >
                <strong>{{ data.value ? data.value.type : '-' }}</strong>
              </div>
              <div v-else>
                {{ data.value ? data.value.type : '-' }}
              </div>
            </template>
          </template>
          <template #head(columnCheck)>
            <div class="form-check">
              <b-form-checkbox
                @change="toggleAll()"
                v-model="allSelected"
                :indeterminate="indeterminate"
                :value="true"
                :disabled="workOrder.wo_status === 'D'"
                :unchecked-value="false"
              ></b-form-checkbox>
            </div>
          </template>
          <template #cell(columnCheck)="data">
            <div class="form-check">
              <b-form-checkbox
                @change="checkTable($event, data.item)"
                v-model="selectedModel[data.index]"
                :value="true"
                :disabled="workOrder.wo_status === 'D' || data.item.tasks_status === 'V'"
                :unchecked-value="false"
              />
            </div>
          </template>
          <template #cell(created_at)="data">
            {{ data.item.created_at ? momentDMHms(data.value) : '-' }}
          </template>
          <template #cell(odometer)="data">
            {{ data.item.odometer ? `${data.value / 1000.0} KM` : '-' }}
          </template>
          <template #cell(fuel_type)="data">
            {{ data.value ? data.value : '-' }}
          </template>
          <template #cell(phone_no)="data">
            {{ data.value ? data.value : '-' }}
          </template>
          <template #cell(gps_type)="data">
            {{ data.value ? data.value : '-' }}
          </template>
          <template #cell(done_by_username)="data">
            {{ data.value ? data.value : '-' }}
          </template>
          <template #cell(fleet_photo)="data">
            <i
              class="mc-fa icon-outline_eye"
              style="font-size: 20px"
              @click="showFleetPhoto(data.item)"
            />
          </template>
          <template #cell(sop)="data">
            <i
              class="mc-fa icon-outline_eye"
              style="font-size: 20px"
              @click="showSOP(data.item.license_plate, data.item.tasks_id, data.item, false)"
            />
          </template>
          <template #cell(checking)="data">
            <i
              class="mc-fa icon-outline_eye"
              style="font-size: 20px"
              @click="showSOP(data.item.license_plate, data.item.tasks_id, data.item, true)"
            />
          </template>
          <template #cell(tasks_status_maintenance)="data">
            <template v-if="data.item.edit_tasks_status_maintenance">
              <b-form-select
                class="form-select form-select-md"
                size="md"
                v-model="data.item.tasks_status_maintenance"
                :options="dropdownOptionsMaintenance"
              />
              <i
                class="mc-fa icon-outline_checkmark"
                style="font-size: 20px"
                @click="confirmUpdate(data, 'tasks_status_maintenance')"
              />
              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEntity(data, 'tasks_status_maintenance')"
              />
            </template>
            <template v-else>
              <span v-if="data.item.tasks_status_maintenance">
                {{ data.value }}
              </span>
              <span v-else>-</span>
              <i
                v-if="
                  data.item.tasks_status !== 'C' &&
                  data.item.isCheckClicked &&
                  data.item.tasks_status !== 'P' &&
                  data.item.tasks_status !== 'D'
                "
                class="mc-fa icon-outline_edit"
                style="font-size: 20px; margin-left: 8px"
                @click="editEntity(data, 'tasks_status_maintenance')"
              />
            </template>
          </template>
          <template #cell(tasks_status)="data">
            <template v-if="data.item.edit_tasks_status">
              <b-form-select
                class="form-select form-select-md"
                size="md"
                v-model="data.item.tasks_status"
                :options="getStatusOptions(data.item)"
              />
              <i
                class="mc-fa icon-outline_checkmark"
                style="font-size: 20px"
                @click="updateEntity(data, 'tasks_status')"
              />
              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEntity(data, 'tasks_status')"
              />
            </template>
            <template v-else>
              <!-- Khusus status 'P' -->
              <span
                v-if="data.item.tasks_status === 'P'"
                class="badge badge-status bg-warning text-white"
                style="cursor: pointer"
                @click="onOpenModalCoordinatorSop(data.item)"
              >
                {{ data.value }}
              </span>
              <!-- Status lainnya -->
              <span v-else-if="data.item.tasks_status">
                {{ data.value }}
              </span>
              <span v-else>-</span>
              <!-- Ikon edit -->
              <i
                v-if="
                  data.item.tasks_status !== 'C' &&
                  data.item.isSopClicked &&
                  data.item.tasks_status !== 'P' &&
                  data.item.tasks_status !== 'D'
                "
                class="mc-fa icon-outline_edit"
                style="font-size: 20px; margin-left: 8px"
                @click="editEntity(data, 'tasks_status')"
              />
            </template>
          </template>
          <template #cell(note)="data">
            <template v-if="data.item.edit_note">
              <b-form-input
                v-model="data.item.note"
                :placeholder="$t('task.column.note')"
                :state="
                  data.item.tasks_status === 'RJ' ? !!checkFieldIsEmpty(data.item.note) : null
                "
                required
              />
              <i
                class="mc-fa icon-outline_checkmark"
                style="font-size: 20px"
                @click="updateEntity(data, 'note')"
              />
              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEntity(data, 'note')"
              />
            </template>
            <template v-else>
              <div @click="editEntity(data, 'note')">
                {{ data.value ? data.value : '-' }}
              </div>
            </template>
          </template>
          <template #cell(license_plate)="data">
            <!-- Kalau bukan move dan sedang edit -->
            <template v-if="!isMove && data.item.edit_license_plate">
              <b-form-input
                v-model="data.item.license_plate"
                :placeholder="$t('task.column.licensePlate')"
                :state="checkFieldIsEmpty(data.item.license_plate) ? null : false"
                required
              />
              <i
                class="mc-fa icon-outline_checkmark"
                style="font-size: 20px"
                :style="{
                  opacity: checkFieldIsEmpty(data.item.license_plate) ? 1 : 0.3,
                  cursor: checkFieldIsEmpty(data.item.license_plate) ? 'pointer' : 'not-allowed',
                }"
                @click="
                  checkFieldIsEmpty(data.item.license_plate)
                    ? updateEntity(data, 'license_plate')
                    : null
                "
              />
              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEntity(data, 'license_plate')"
              />
            </template>

            <!-- Kalau move, atau bukan edit mode -->
            <template v-else>
              <div
                v-if="workOrder.wo_status !== 'D' && data.item.tasks_status !== 'V'"
                @click="
                  !isMove &&
                    workOrder.wo_type !== 'maintenance' &&
                    editEntity(data, 'license_plate')
                "
              >
                {{ data.value ? data.value : '-' }}
              </div>
              <div v-else>
                {{ data.value ? data.value : '-' }}
              </div>
            </template>
          </template>

          <template v-if="isMove" #cell(target_license_plate)="data">
            {{ data.item.target_vehicle?.license_plate || '-' }}
          </template>
          <template #cell(wo_line_id)="data">
            <template v-if="data.item.edit_wo_line_id">
              <b-form-input
                v-model.number="data.item.wo_line_id"
                type="number"
                min="0"
                step="1"
                @input="validateWoLineId(data)"
                :placeholder="$t('task.column.workOrderLineId')"
              />
              <i
                class="mc-fa icon-outline_checkmark"
                style="font-size: 20px"
                @click="updateEntity(data, 'wo_line_id')"
              />
              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEntity(data, 'wo_line_id')"
              />
            </template>
            <template v-else>
              <div
                v-if="workOrder.wo_status !== 'D' && data.item.tasks_status !== 'V'"
                @click="editEntity(data, 'wo_line_id')"
              >
                {{ data.value ? data.value : '-' }}
              </div>
              <div v-else>
                {{ data.value ? data.value : '-' }}
              </div>
            </template>
          </template>
          <template #cell(hull_no)="data">
            <template v-if="data.item.edit_hull_no">
              <b-form-input v-model="data.item.hull_no" :placeholder="$t('vehicle.hullNo')" />
              <i
                class="mc-fa icon-outline_checkmark"
                style="font-size: 20px"
                @click="updateEntity(data, 'hull_no')"
              />
              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEntity(data, 'hull_no')"
              />
            </template>
            <template v-else>
              <div
                v-if="workOrder.wo_status !== 'D' && data.item.tasks_status !== 'V'"
                @click="editEntity(data, 'hull_no')"
              >
                {{ data.value ? data.value : '-' }}
              </div>
              <div v-else>
                {{ data.value ? data.value : '-' }}
              </div>
            </template>
          </template>
          <template v-if="isMove" #cell(origin_vgroups)="data">
            <!-- VIEW MODE -->
            <div>
              <!-- VIEW MODE -->
              <div v-if="data.item.vehicle?.vgroups?.length">
                <b-badge
                  v-for="v in data.item.vehicle.vgroups"
                  :key="v.vgroup_id"
                  class="bg-primary text-white me-1 mb-1"
                >
                  {{ v.name }}
                </b-badge>
              </div>

              <div v-else>-</div>
            </div>
          </template>
          <template v-if="isMove" #cell(target_vgroups)="data">
            <!-- EDIT MODE -->
            <div v-if="data.item.edit_target_vgroups">
              <multiselect
                ref="refTargetVgroups"
                v-model="data.item.target_vehicle.vgroups"
                :options="vgroupOptions"
                label="name"
                :placeholder="$t('Pilih Vgroups')"
                track-by="vgroup_id"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :hide-selected="true"
                :allow-empty="true"
                open-direction="bottom"
                @open="adjustTableHeight('target_vgroups')"
              />

              <i
                class="mc-fa icon-outline_checkmark"
                style="font-size: 20px"
                @click="updateTargetVgroups(data)"
              />

              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEntity(data, 'target_vgroups')"
              />
            </div>

            <!-- VIEW MODE -->
            <div v-else>
              <!-- VIEW MODE -->
              <div
                v-if="data.item.target_vehicle?.vgroups?.length"
                @click="editEntity(data, 'target_vgroups')"
                style="cursor: pointer"
              >
                <b-badge
                  v-for="v in data.item.target_vehicle.vgroups"
                  :key="v.vgroup_id"
                  class="bg-primary text-white me-1 mb-1"
                >
                  {{ v.name }}
                </b-badge>
              </div>

              <div v-else @click="editEntity(data, 'target_vgroups')" style="cursor: pointer">
                -
              </div>
            </div>
          </template>
          <template #cell(category)="data">
            {{ data.item.device?.vehicle?.vehicle_type?.category || '-' }}
          </template>
          <template #cell(fuelTypeName)="data">
            {{ data.item.device?.vehicle?.vehicle_type?.fuelTypeName || '-' }}
          </template>
        </b-table>
      </div>

      <b-modal
        id="modal-sop"
        centered
        :title="`${$t('task.column.sop')} : ${licensePlate}`"
        okOnly
        hideHeaderClose
        :okTitle="$t('global.close')"
        okVariant="dark"
        size="lg"
      >
        <div v-for="item in SOP(tasksId, isCheck)" :key="item.tc_id">
          <template
            v-if="
              item.checklist_name.startsWith('Foto') || (item.photo !== null && item.photo !== '')
            "
          >
            <b-row class="mb-2">
              <b-col>
                <b-form-group
                  :id="'sop-label-' + item.tc_id"
                  label-align="left"
                  :label="item.checklist_name"
                  :label-for="`sop-label-${item.tc_id}`"
                />
              </b-col>
              <b-col
                ><i
                  class="mc-fa icon-outline_camera"
                  style="font-size: 20px; margin-left: 5px; float: right"
                  v-b-toggle="`sop-b-toggle-${item.tc_id}`"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <template v-if="item.photo">
                <b-collapse :id="`sop-b-toggle-${item.tc_id}`">
                  <img
                    :src="item.url"
                    :alt="item.checklist_name"
                    style="width: 100%; height: 300px; object-fit: contain"
                  />
                </b-collapse>
              </template>
            </b-row>
          </template>

          <!-- Non-Startswith Photo -->
          <template v-else>
            <!-- Header -->
            <b-row class="mb-2 header">
              <b-input-group>
                <b-form-input
                  :id="`sop-input-${item.tc_id}`"
                  v-model="item.checklist_name"
                  class="mc-pointer-none"
                  readonly
                />
                <b-input-group-append>
                  <b-input-group-text>
                    <template v-if="item.tasks_checklist_detail !== undefined">
                      <i
                        class="mc-fa icon-outline_eye"
                        style="font-size: 20px; margin-left: 5px; float: right"
                        v-b-toggle="`sop-b-toggle-${item.tc_id}`"
                      />
                    </template>
                    <template v-else>
                      <i
                        class="mc-fa icon-outline_eye-off"
                        style="font-size: 20px; margin-left: 5px; float: right"
                        v-b-toggle="`sop-b-toggle-${item.tc_id}`"
                      />
                    </template>
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-row>

            <!-- Header's Collapse -->
            <b-row class="mb-2 header-collapse">
              <b-collapse :id="`sop-b-toggle-${item.tc_id}`">
                <template v-if="item.tasks_checklist_detail !== undefined">
                  <!-- Header's Content -->
                  <b-table-simple class="mb-2" bordered responsive>
                    <b-tbody>
                      <template v-for="tcd in item.tasks_checklist_detail">
                        <!-- Subheader  -->
                        <b-tr
                          class="accordion"
                          v-for="(cdt, iCdt) in tcd.type"
                          :key="cdt + tcd.checklist_detail_id"
                        >
                          <template v-if="tcd.type.length > 1">
                            <template v-if="iCdt === 0">
                              <b-td
                                :rowspan="tcd.type.length"
                                style="text-align: justify; vertical-align: middle"
                              >
                                {{ tcd.description }}
                              </b-td>
                              <b-td style="text-align: center; vertical-align: middle">
                                <!-- TAMBAHKAN INI UNTUK RCD/SD/CUCWO -->
                                <template v-if="cdt === 'RCD' || cdt === 'SD' || cdt === 'CUCWO'">
                                  <i
                                    class="mc-fa icon-outline_eye"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdForm-b-toggle-${tcd.tcd_id}`)"
                                  />
                                </template>
                                <template v-else-if="cdt === 'C'">
                                  <b-form-checkbox size="md" v-model="tcd.check" disabled />
                                </template>
                                <template
                                  v-else-if="
                                    cdt !== 'C' &&
                                    cdt !== 'D' &&
                                    cdt !== 'N' &&
                                    cdt !== 'NB' &&
                                    cdt !== 'NN' &&
                                    cdt !== 'SCWD'
                                  "
                                >
                                  <i
                                    v-if="tcd.photo != null"
                                    class="mc-fa icon-fill_camera"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdPhoto-b-toggle-${tcd.tcd_id}`)"
                                  />
                                  <i
                                    v-else
                                    class="mc-fa icon-outline_camera"
                                    style="font-size: 20px"
                                  />
                                </template>
                                <template
                                  v-else-if="
                                    cdt === 'N' || cdt === 'NB' || cdt === 'NN' || cdt === 'SCWD'
                                  "
                                >
                                  <i
                                    v-if="tcd.note != null"
                                    class="mc-fa icon-fill_message-square"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdNote-b-toggle-${tcd.tcd_id}`)"
                                  />
                                  <i
                                    v-else
                                    class="mc-fa icon-outline_message-square"
                                    style="font-size: 20px"
                                  />
                                </template>
                                <template v-else-if="cdt === 'D'">
                                  <i
                                    v-if="tcd.note != null"
                                    class="mc-fa icon-fill_arrrow-down"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdDropdown-b-toggle-${tcd.tcd_id}`)"
                                  />
                                  <i
                                    v-else
                                    class="mc-fa icon-outline_message-square"
                                    style="font-size: 20px"
                                  />
                                </template>
                              </b-td>
                            </template>

                            <!-- index after 0 -->
                            <template v-else>
                              <b-td style="text-align: center; vertical-align: middle">
                                <!-- TAMBAHKAN INI UNTUK RCD/SD/CUCWO -->
                                <template v-if="cdt === 'RCD' || cdt === 'SD' || cdt === 'CUCWO'">
                                  <i
                                    class="mc-fa icon-outline_eye"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdForm-b-toggle-${tcd.tcd_id}`)"
                                  />
                                </template>
                                <template v-else-if="cdt === 'C'">
                                  <b-form-checkbox
                                    size="md"
                                    v-model="tcd.check"
                                    disabled
                                  ></b-form-checkbox>
                                </template>
                                <template
                                  v-else-if="
                                    cdt !== 'C' &&
                                    cdt !== 'D' &&
                                    cdt !== 'N' &&
                                    cdt !== 'NB' &&
                                    cdt !== 'SCWD' &&
                                    cdt !== 'NN'
                                  "
                                >
                                  <i
                                    v-if="tcd.photo != null"
                                    class="mc-fa icon-fill_camera"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdPhoto-b-toggle-${tcd.tcd_id}`)"
                                  />
                                  <i
                                    v-else
                                    class="mc-fa icon-outline_camera"
                                    style="font-size: 20px"
                                  />
                                </template>
                                <template
                                  v-else-if="
                                    cdt === 'N' || cdt === 'NB' || cdt === 'SCWD' || cdt === 'NN'
                                  "
                                >
                                  <i
                                    v-if="tcd.note != null"
                                    class="mc-fa icon-fill_message-square"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdNote-b-toggle-${tcd.tcd_id}`)"
                                  />
                                  <i
                                    v-else
                                    class="mc-fa icon-outline_message-square"
                                    style="font-size: 20px"
                                  />
                                </template>
                                <template v-else-if="cdt === 'D'">
                                  <i
                                    v-if="tcd.note != null"
                                    class="mc-fa icon-fill_arrrow-down"
                                    style="font-size: 20px"
                                    @click="showItem(`tcdDropdown-b-toggle-${tcd.tcd_id}`)"
                                  />
                                  <i
                                    v-else
                                    class="mc-fa icon-outline_message-square"
                                    style="font-size: 20px"
                                  />
                                </template>
                              </b-td>
                            </template>
                          </template>

                          <!-- tcd only contains 1 type -->
                          <template v-else>
                            <!-- Desc column -->
                            <b-td
                              v-if="tcd.flag === 'UnidentifiedComponent' && cdt === 'NN'"
                              style="text-align: justify; vertical-align: middle"
                            >
                              {{ tcd.productName }}
                            </b-td>
                            <b-td
                              v-else-if="item.flag === 'Replacement'"
                              style="text-align: justify; vertical-align: middle"
                            >
                              Replacement {{ tcd.description }}
                            </b-td>
                            <b-td
                              v-else-if="cdt === 'NN'"
                              style="text-align: justify; vertical-align: middle"
                            >
                              {{ tcd.note.includes('|') ? tcd.note.split('|')[1] : tcd.note }}
                            </b-td>
                            <b-td v-else style="text-align: justify; vertical-align: middle">
                              {{ tcd.description }}
                            </b-td>

                            <!-- Action Column -->
                            <b-td style="text-align: center; vertical-align: middle">
                              <!-- TAMBAHKAN INI UNTUK RCD/SD/CUCWO -->
                              <template v-if="cdt === 'RCD' || cdt === 'SD' || cdt === 'CUCWO'">
                                <i
                                  class="mc-fa icon-outline_eye"
                                  style="font-size: 20px"
                                  @click="showItem(`tcdForm-b-toggle-${tcd.tcd_id}`)"
                                />
                              </template>
                              <template v-else-if="cdt === 'SCSABP' || cdt === 'SCSDBP'">
                                <i
                                  v-if="tcd.photo != null"
                                  class="mc-fa icon-fill_camera"
                                  style="font-size: 20px"
                                  @click="
                                    () => {
                                      if (isElementShown(`tcdPhoto-b-toggle-${tcd.tcd_id}`)) {
                                        hideItem(`tcdPhoto-b-toggle-${tcd.tcd_id}`, true)
                                      } else {
                                        hideItem(`tcdPhoto-b-toggle-${tcd.tcd_id}`, false)
                                        expandedAdasDmsTcdId = null
                                      }
                                    }
                                  "
                                />
                                {{ '   ' }}
                                <i
                                  class="mc-fa icon-outline_eye"
                                  style="font-size: 20px"
                                  @click="
                                    getAdasDmsChecklist(
                                      tcd.tcd_id,
                                      item.tasks_id,
                                      cdt === 'SCSABP' ? 'adas' : 'dms'
                                    )
                                  "
                                />
                              </template>
                              <template v-else-if="cdt === 'C'">
                                <b-form-checkbox
                                  size="md"
                                  v-model="tcd.check"
                                  disabled
                                ></b-form-checkbox>
                              </template>
                              <template v-else-if="cdt === 'NN'">
                                <i
                                  v-if="tcd.note != null"
                                  class="mc-fa icon-fill_message-square"
                                  style="font-size: 20px"
                                  @click="showItem(`tcdNote-b-toggle-${tcd.tcd_id}`)"
                                />
                                <i
                                  v-else
                                  class="mc-fa icon-outline_message-square"
                                  style="font-size: 20px"
                                >
                                </i>
                              </template>
                              <template
                                v-else-if="
                                  cdt !== 'C' &&
                                  cdt !== 'D' &&
                                  cdt !== 'N' &&
                                  cdt !== 'NB' &&
                                  cdt !== 'SCWD'
                                "
                              >
                                <i
                                  v-if="tcd.photo != null"
                                  class="mc-fa icon-fill_camera"
                                  style="font-size: 20px"
                                  @click="showItem(`tcdPhoto-b-toggle-${tcd.tcd_id}`)"
                                />
                                <i
                                  v-else
                                  class="mc-fa icon-outline_camera"
                                  style="font-size: 20px"
                                />
                              </template>
                              <template v-else-if="cdt === 'N' || cdt === 'NB' || cdt === 'SCWD'">
                                <i
                                  v-if="tcd.note != null"
                                  class="mc-fa icon-fill_message-square"
                                  style="font-size: 20px"
                                  @click="showItem(`tcdNote-b-toggle-${tcd.tcd_id}`)"
                                />
                                <i
                                  v-else
                                  class="mc-fa icon-outline_message-square"
                                  style="font-size: 20px"
                                >
                                </i>
                              </template>
                              <template v-else-if="cdt === 'D' && item.flag === 'Replacement'">
                                <i
                                  class="mc-fa icon-fill_arrrow-down"
                                  style="font-size: 20px"
                                  @click="showItem(`tcdDropdown-b-toggle-${tcd.tcd_id}`)"
                                />
                              </template>
                              <template v-else-if="cdt === 'D'">
                                <i
                                  v-if="tcd.note != null"
                                  class="mc-fa icon-fill_arrrow-down"
                                  style="font-size: 20px"
                                  @click="showItem(`tcdDropdown-b-toggle-${tcd.tcd_id}`)"
                                />
                                <i
                                  v-else
                                  class="mc-fa icon-outline_message-square"
                                  style="font-size: 20px"
                                >
                                </i>
                              </template>
                            </b-td>
                          </template>
                        </b-tr>

                        <!-- Subheader Collapse -->
                        <template v-for="cdt in tcd.type">
                          <template v-if="cdt === 'RCD' || cdt === 'SD' || cdt === 'CUCWO'">
                            <b-tr
                              :ref="`tcdForm-b-toggle-${tcd.tcd_id}`"
                              :key="`collapse${cdt}` + tcd.checklist_detail_id"
                              style="display: none"
                            >
                              <b-td colspan="2" style="padding: 1rem">
                                <!-- RCD -->
                                <div v-if="cdt === 'RCD'" class="p-3 border rounded">
                                  <h6 class="mb-3">RCD – Register Create Device</h6>
                                  <FormCreateDevice
                                    :form="getRCDFormData(selectedTask)"
                                    :disabledRCD="true"
                                    :deviceTypeOptions="[]"
                                    :isEdit="true"
                                    :hasAccessAll="true"
                                    :accordionVisible="false"
                                    :responseModal="{}"
                                  />
                                </div>
                                <!-- SD -->
                                <div v-else-if="cdt === 'SD'" class="p-3 border rounded">
                                  <h6 class="mb-3">SD – Set Device to Customer</h6>
                                  <FormDeviceSetToCustomer
                                    v-model="set"
                                    :disabledSD="true"
                                    :taskData="selectedTask"
                                    :isEdit="true"
                                  />
                                </div>
                                <!-- CUCWO -->
                                <div v-else-if="cdt === 'CUCWO'" class="p-3 border rounded">
                                  <h6 class="mb-3">CUCWO – Check & Update Work Order</h6>
                                  <div class="alert alert-info">
                                    Status:
                                    <span v-if="tcd.check === true">✅ Selesai</span>
                                    <span v-else>⏳ Belum selesai</span>
                                  </div>
                                </div>
                              </b-td>
                            </b-tr>
                          </template>
                          <template v-else-if="cdt === 'SCSABP' || cdt === 'SCSDBP'">
                            <!-- both media and nested table -->
                            <b-tr
                              :ref="`tcdPhoto-b-toggle-${tcd.tcd_id}`"
                              :key="`collapse${cdt}` + tcd.checklist_detail_id"
                              style="display: none"
                            >
                              <b-td colspan="2">
                                <template v-if="tcd.photo != null">
                                  <video
                                    v-if="isVideo(tcd.url)"
                                    :src="tcd.url"
                                    class="mb-2"
                                    controls
                                    style="width: 100%; height: 300px; object-fit: contain"
                                  />
                                  <img
                                    v-else
                                    :src="tcd.url"
                                    :alt="tcd.photo"
                                    class="mb-2"
                                    style="width: 100%; height: 300px; object-fit: contain"
                                  />
                                </template>
                                <div class="text-center text-muted" v-else>
                                  {{ $t('global.emptyTable') }}
                                </div>
                              </b-td>
                            </b-tr>
                            <b-tr
                              :ref="`adas-dms-tcdForm-b-toggle-${tcd.tcd_id}`"
                              :key="`adas-dms-collapse${cdt}` + tcd.checklist_detail_id"
                              :style="{
                                display: expandedAdasDmsTcdId === tcd.tcd_id ? '' : 'none',
                              }"
                            >
                              <b-td colspan="2">
                                <b-table-simple class="mt-2" bordered responsive>
                                  <b-tbody>
                                    <!-- Subheader  -->
                                    <b-tr
                                      class="accordion"
                                      v-for="adasdms in adasDmsRows[cdt]"
                                      :key="adasdms.label + tcd.tcd_id"
                                    >
                                      <b-td>{{ adasdms.label }}</b-td>
                                      <b-td style="text-align: center; vertical-align: middle">
                                        <template>
                                          <i
                                            :class="`mc-fa icon-${
                                              adasDmsData?.[adasdms.key]?.photo_url
                                                ? 'fill'
                                                : 'outline'
                                            }_camera`"
                                            style="font-size: 20px"
                                            @click="
                                              openMediaPreview(adasdms.key, adasdms.label, 'photo')
                                            "
                                          />
                                          {{ '   ' }}
                                          <i
                                            :class="`mc-fa icon-${
                                              adasDmsData?.[adasdms.key]?.video_url
                                                ? 'fill'
                                                : 'outline'
                                            }_video`"
                                            style="font-size: 20px"
                                            @click="
                                              openMediaPreview(adasdms.key, adasdms.label, 'video')
                                            "
                                          />
                                        </template>
                                      </b-td>
                                    </b-tr>
                                  </b-tbody>
                                </b-table-simple>
                              </b-td>
                            </b-tr>
                          </template>
                          <template
                            v-else-if="
                              cdt !== 'C' &&
                              cdt !== 'D' &&
                              cdt !== 'N' &&
                              cdt !== 'NB' &&
                              cdt !== 'NN' &&
                              cdt !== 'SCWD'
                            "
                          >
                            <b-tr
                              :ref="`tcdPhoto-b-toggle-${tcd.tcd_id}`"
                              :key="`collapse${cdt}` + tcd.checklist_detail_id"
                              style="display: none"
                            >
                              <b-td colspan="2">
                                <template v-if="tcd.photo != null">
                                  <video
                                    v-if="isVideo(tcd.url)"
                                    :src="tcd.url"
                                    class="mb-2"
                                    controls
                                    style="width: 100%; height: 300px; object-fit: contain"
                                  />
                                  <img
                                    v-else
                                    :src="tcd.url"
                                    :alt="tcd.photo"
                                    class="mb-2"
                                    style="width: 100%; height: 300px; object-fit: contain"
                                  />
                                </template>
                                <div class="text-center text-muted" v-else>
                                  {{ $t('global.emptyTable') }}
                                </div>
                              </b-td>
                            </b-tr>
                          </template>
                          <template v-else-if="cdt === 'NN'">
                            <b-tr
                              :ref="`tcdNote-b-toggle-${tcd.tcd_id}`"
                              :key="`collapse${cdt}` + tcd.checklist_detail_id"
                              style="display: none"
                            >
                              <b-td colspan="2">
                                <b-form-input
                                  v-if="tcd.note != null && tcd.note.split('|').length > 1"
                                  :id="`tcdNote-input-${tcd.tcd_id}`"
                                  :value="tcd.qty"
                                  class="mb-2"
                                  readonly
                                />
                                <b-form-input
                                  v-else-if="tcd.note.split('|').length === 1"
                                  :id="`tcdNote-input-${tcd.tcd_id}`"
                                  :value="tcd.note"
                                  class="mb-2"
                                  readonly
                                />
                                <div class="text-center text-muted" v-else>
                                  {{ $t('global.emptyTable') }}
                                </div>
                              </b-td>
                            </b-tr>
                          </template>
                          <template v-else-if="item.flag === 'Replacement'">
                            <b-tr
                              :ref="`tcdDropdown-b-toggle-${tcd.tcd_id}`"
                              :key="`collapse${cdt}` + tcd.checklist_detail_id"
                              style="display: none"
                            >
                              <b-td colspan="2">
                                <b-form-input
                                  v-if="tcd.note"
                                  :id="`tcdDropdown-b-input-${tcd.tcd_id}`"
                                  :value="tcd.componentReplacement"
                                  class="mb-2"
                                  readonly
                                />
                                <div class="text-center text-muted" v-else>
                                  {{ $t('global.emptyTable') }}
                                </div>
                              </b-td>
                            </b-tr>
                          </template>
                          <template v-else-if="cdt === 'D'">
                            <b-tr
                              :ref="`tcdDropdown-b-toggle-${tcd.tcd_id}`"
                              :key="`collapse${cdt}` + tcd.checklist_detail_id"
                              style="display: none"
                            >
                              <b-td colspan="2">
                                <b-form-input
                                  v-if="tcd.note != null"
                                  :id="`tcdDropdown-input-${tcd.tcd_id}`"
                                  v-model="tcd.note.split('|')[0]"
                                  class="mb-2"
                                  readonly
                                />
                                <div class="text-center text-muted" v-else>
                                  {{ $t('global.emptyTable') }}
                                </div>
                              </b-td>
                            </b-tr>
                          </template>
                          <template v-else-if="cdt === 'N' || cdt === 'NB' || cdt === 'SCWD'">
                            <b-tr
                              :ref="`tcdNote-b-toggle-${tcd.tcd_id}`"
                              :key="`collapse${cdt}` + tcd.checklist_detail_id"
                              style="display: none"
                            >
                              <b-td colspan="2">
                                <b-form-textarea
                                  v-if="tcd.note != null"
                                  :id="`tcdNote-input-${tcd.tcd_id}`"
                                  :value="
                                    tcd.note.includes('|') ? tcd.note.split('|')[1] : tcd.note
                                  "
                                  class="mb-2"
                                  :rows="6"
                                  readonly
                                />
                                <div class="text-center text-muted" v-else>
                                  {{ $t('global.emptyTable') }}
                                </div>
                              </b-td>
                            </b-tr>
                          </template>
                        </template>
                      </template>
                    </b-tbody>
                  </b-table-simple>
                </template>
              </b-collapse>
            </b-row>
          </template>
        </div>
      </b-modal>

      <b-modal
        id="modal-fleetPhoto"
        centered
        :title="`${$t('task.column.fleetPhoto')} : ${licensePlate}`"
        okOnly
        hideHeaderClose
        :okTitle="$t('global.close')"
        okVariant="dark"
      >
        <div>
          <b-row class="mb-2">
            <b-col>
              <b-form-group
                :id="`imeiPhoto-label-${taskId}`"
                label-align="left"
                :label="
                  this.workOrder.type == 'install'
                    ? $t('task.column.imeiPhoto')
                    : $t('task.column.nopol')
                "
                :label-for="`imeiPhoto-label-${taskId}`"
              />
            </b-col>
            <b-col
              ><i
                class="mc-fa icon-outline_camera"
                style="font-size: 20px; margin-left: 5px; float: right"
                v-b-toggle="`imeiPhoto-b-toggle-${taskId}`"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <template v-if="imeiPhoto">
              <b-collapse :id="`imeiPhoto-b-toggle-${taskId}`">
                <img
                  :src="imeiPhotoS3"
                  :alt="imeiPhoto"
                  style="width: 100%; height: 300px; object-fit: contain"
                />
              </b-collapse>
            </template>
          </b-row>
        </div>
        <div>
          <b-row class="mb-2">
            <b-col>
              <b-form-group
                :id="`licensePlatePhoto-label-${taskId}`"
                label-align="left"
                :label="
                  this.workOrder.type == 'install'
                    ? $t('task.column.licensePlatePhoto')
                    : $t('task.column.oldImei')
                "
                :label-for="`licensePlatePhoto-label-${taskId}`"
              />
            </b-col>
            <b-col
              ><i
                class="mc-fa icon-outline_camera"
                style="font-size: 20px; margin-left: 5px; float: right"
                v-b-toggle="`licensePlatePhoto-b-toggle-${taskId}`"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <template v-if="licensePlatePhoto">
              <b-collapse :id="`licensePlatePhoto-b-toggle-${taskId}`">
                <img
                  :src="licensePlatePhotoS3"
                  :alt="licensePlatePhoto"
                  style="width: 100%; height: 300px; object-fit: contain"
                />
              </b-collapse>
            </template>
          </b-row>
        </div>
        <div v-if="taskType !== 'A'">
          <b-row class="mb-2">
            <b-col>
              <b-form-group
                :id="`odometerPhoto-label-${taskId}`"
                label-align="left"
                :label="$t('task.column.odometerPhoto')"
                :label-for="`odometerPhoto-label-${taskId}`"
              />
            </b-col>
            <b-col
              ><i
                class="mc-fa icon-outline_camera"
                style="font-size: 20px; margin-left: 5px; float: right"
                v-b-toggle="`odometerPhoto-b-toggle-${taskId}`"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <template v-if="odometerPhoto">
              <b-collapse :id="`odometerPhoto-b-toggle-${taskId}`">
                <img
                  :src="odometerPhotoS3"
                  :alt="odometerPhoto"
                  style="width: 100%; height: 300px; object-fit: contain"
                />
              </b-collapse>
            </template>
          </b-row>
        </div>
        <div>
          <b-row class="mb-2">
            <b-col>
              <b-form-group
                :id="`vehicleFullPhoto-label-${taskId}`"
                label-align="left"
                :label="$t('task.column.vehicleFullPhoto')"
                :label-for="`vehicleFullPhoto-label-${taskId}`"
              />
            </b-col>
            <b-col
              ><i
                class="mc-fa icon-outline_camera"
                style="font-size: 20px; margin-left: 5px; float: right"
                v-b-toggle="`vehicleFullPhoto-b-toggle-${taskId}`"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <template v-if="vehicleFullPhoto">
              <b-collapse :id="`vehicleFullPhoto-b-toggle-${taskId}`">
                <img
                  :src="vehicleFullPhotoS3"
                  :alt="vehicleFullPhoto"
                  style="width: 100%; height: 300px; object-fit: contain"
                />
              </b-collapse>
            </template>
          </b-row>
        </div>
        <div>
          <b-row class="mb-2">
            <b-col>
              <b-form-group
                :id="`rearVehiclePhoto-label-${taskId}`"
                label-align="left"
                :label="$t('task.column.rearVehiclePhoto')"
                :label-for="`rearVehiclePhoto-label-${taskId}`"
              />
            </b-col>
            <b-col
              ><i
                class="mc-fa icon-outline_camera"
                style="font-size: 20px; margin-left: 5px; float: right"
                v-b-toggle="`rearVehiclePhoto-b-toggle-${taskId}`"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <template v-if="rearVehiclePhoto">
              <b-collapse :id="`rearVehiclePhoto-b-toggle-${taskId}`">
                <img
                  :src="rearVehiclePhotoS3"
                  :alt="rearVehiclePhoto"
                  style="width: 100%; height: 300px; object-fit: contain"
                />
              </b-collapse>
            </template>
          </b-row>
        </div>
      </b-modal>

      <b-modal
        id="modal-media-preview"
        centered
        :title="mediaPreviewTitle"
        okOnly
        hideHeaderClose
        :okTitle="$t('global.close')"
        okVariant="dark"
        size="lg"
      >
        <div v-if="mediaPreviewDate">Tanggal Peringatan: {{ mediaPreviewDate }}</div>

        <template v-if="mediaPreviewUrl">
          <video
            v-if="isVideo(mediaPreviewUrl)"
            :src="mediaPreviewUrl"
            controls
            style="width: 100%; max-height: 70vh; object-fit: contain"
          />
          <img
            v-else
            :src="mediaPreviewUrl"
            style="width: 100%; max-height: 70vh; object-fit: contain"
          />
        </template>
      </b-modal>
    </b-card>

    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">{{ $t('verify.title') }}</h4>
      </div>
    </div>

    <b-card>
      <b-row>
        <b-col class="col-6" sm="3" md="2">
          <b-form-group id="rating" :label="$t('verify.column.rating')" label-for="rating">
          </b-form-group>
        </b-col>
        :
        <b-col class="col-5" sm="2" md="1">
          <div>
            <i
              v-for="i in 5"
              :key="i"
              :class="[
                'fa fa-star',
                !rate?.rate || rate.rate === 0
                  ? 'text-muted'
                  : i > rate.rate
                  ? 'text-muted'
                  : 'text-warning',
              ]"
            ></i>
          </div>
        </b-col>
        <b-col class="col-6" sm="3" md="2">
          <b-form-group id="signature" :label="$t('verify.column.signature')" label-for="signature">
          </b-form-group>
        </b-col>
        :
        <b-col class="col-5" sm="2" md="1">
          <i
            class="mc-fa icon-outline_camera"
            style="font-size: 20px; margin-left: 5px; float: right"
            v-b-toggle="`sign-b-toggle-${rate.rate_id}`"
          />
        </b-col>
        <b-col class="col-6" sm="3" md="2">
          <b-form-group id="selfie" :label="$t('verify.column.selfie')" label-for="selfie">
          </b-form-group>
        </b-col>
        :
        <b-col class="col-5" sm="2" md="1">
          <i
            class="mc-fa icon-outline_camera"
            style="font-size: 20px; margin-left: 5px; float: right"
            v-b-toggle="`selfie-b-toggle-${rate.rate_id}`"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-1" sm="1" md="3"> </b-col>
        <b-col class="col-5" sm="5" md="3">
          <b-collapse :id="`sign-b-toggle-${rate.rate_id}`">
            <template v-if="rate.sign_photo">
              <img
                :src="rate.sign_url"
                :alt="rate.sign_photo"
                style="width: 100%; height: 300px; object-fit: contain"
              />
            </template>
          </b-collapse>
        </b-col>
        <b-col class="col-5" sm="5" md="3">
          <b-collapse :id="`selfie-b-toggle-${rate.rate_id}`">
            <template v-if="rate.sign_selfie_photo">
              <img
                :src="rate.sign_selfie_url"
                :alt="rate.sign_selfie_photo"
                style="width: 100%; height: 300px; object-fit: contain"
              />
            </template>
          </b-collapse>
        </b-col>
      </b-row>
    </b-card>

    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">{{ $t('verify.internalNote') }}</h4>
      </div>
    </div>

    <b-card>
      <div :class="{ 'editor-locked': !isEditingInternalNote }">
        <VueEditor
          v-if="workOrder.wo_status !== 'D'"
          id="editor"
          :editorOptions="editorSettings"
          v-model="workOrder.new_internal_note"
          :disabled="!isEditingInternalNote && !!workOrder.new_internal_note"
          :useCustomImageHandler="true"
          @image-added="handleEditorImageAdded"
        />
        <div v-else class="editor-view" v-html="workOrder.new_internal_note"></div>
      </div>
      <div v-if="workOrder.wo_status !== 'D'" class="mt-3">
        <b-button
          v-if="isEditingInternalNote"
          variant="primary"
          :disabled="this.loading"
          @click="saveInternalNote"
        >
          Save
        </b-button>
        <b-button
          v-else
          variant="outline-primary"
          :disabled="this.loading"
          @click="editInternalNote"
        >
          Edit
        </b-button>
      </div>
    </b-card>

    <b-modal
      id="modal-cancelWo"
      centered
      :title="`${workOrder.wo_number}`"
      hideHeaderClose
      :okTitle="$t('global.yes')"
      :cancelTitle="$t('global.no')"
      okVariant="dark"
      @ok="handleCancel"
    >
      <p>
        {{ $t('workOrder.areYouCancel') }}
        <b>{{ workOrder.wo_number }}</b
        >?
      </p>
    </b-modal>

    <ModalCoordinatorSop
      v-model="showModalCoordinatorSop"
      :taskId="selectedTaskId"
      :licensePlate="selectedLicensePlate"
      :imei="selectedImei"
      :taskData="taskData"
      :woType="workOrder.type"
      @saved="onSavedCoordinatorSop"
      @data-updated="refreshTaskDataOnly"
    />

    <ModalClockInPhoto v-if="clockInData" :clockInData="clockInData" />
    <ConfirmationV2
      v-if="modalConfirm"
      :modal.sync="modalConfirm"
      :message="`Peringatan! <br><br>
Perubahan healthy check akan berpengaruh ke data menjadi tidak konsisten, harap melakukan check data Pelacak, WO websms, dan data ERP sebelum dilakukan perubahan`"
      @confirmed="onSubmit"
    />
  </Layout>
</template>

<style>
.badge-status {
  font-size: 0.9rem !important;
  /* atau 1rem sesuai keinginan */
  padding: 0.4rem 0.7rem !important;
  font-weight: 600;
}

.hidden-header {
  display: none;
}

.mc-pointer-none {
  pointer-events: none;
}

.rowContent {
  display: none;
}
</style>

<style scoped>
::v-deep .editor-locked .ql-editor img {
  pointer-events: none !important;
  cursor: default;
}

::v-deep .editor-locked .ql-container > div:last-child {
  display: none !important;
}

::v-deep .multiselect__tag {
  background-color: #0d6efd !important;
}

::v-deep .multiselect__tag span {
  color: #fff !important;
}

::v-deep .multiselect__tag-icon:after {
  color: #fff !important;
}
</style>
